export default {
  message: '中文繁体'
}
